// src/components/SideDrawer.tsx
import React, { Fragment } from "react";

interface SideDrawerProps {
	isOpen: boolean;
	onClose: () => void;
	header: React.ReactNode;
	children: React.ReactNode;
}

const SideDrawer = ({ isOpen, onClose, children, header }: SideDrawerProps) => {
	return (
		<Fragment>
			{/* Backdrop */}
			<div
				className={`fixed inset-0 z-40 bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out ${
					isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
				}`}
				onClick={onClose}
			></div>

			{/* Drawer */}
			<div
				className={`fixed top-0 right-0 h-full w-80 max-w-[90vw] bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${
					isOpen ? "translate-x-0" : "translate-x-full"
				}`}
				role="dialog"
				aria-modal="true"
				aria-labelledby="drawer-title"
			>
				<div className="flex flex-col h-full">
					{/* Drawer Header */}
					{header}

					{/* Drawer Content */}
					<div className="flex-grow p-4 overflow-y-auto">{children}</div>
				</div>
			</div>
		</Fragment>
	);
};

export default SideDrawer;
